import React, {Component} from 'react'
import AuthLoading from "@/pages/AuthLoading";

export default class App extends Component<{}> {

    render() {
        return <AuthLoading />
    }
}